(function() {
  ('use strict');

  /**
   * Campaign Parameter Handler
   *
   * This script captures the 'code' parameter from the URL (e.g., ?code=EARLY),
   * stores it in sessionStorage, and automatically appends it to all internal links
   * throughout the user's browsing session.
   *
   * If a user lands on a page without a 'code' parameter, any existing campaign code
   * is removed from sessionStorage to ensure campaign tracking is only active when
   * explicitly present in the URL.
   */

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function addParameterToUrl(url, paramName, paramValue) {
    if (!url || !paramValue) return url;

    var urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set(paramName, paramValue);
    return urlObj.toString();
  }

  function isInternalLink(href) {
    if (!href) return false;

    if (
      href.startsWith('#') ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('data:') ||
      href.startsWith('blob:')
    ) {
      return false;
    }

    try {
      var url = new URL(href, window.location.origin);
      return url.hostname === window.location.hostname;
    } catch (e) {
      return true;
    }
  }

  function processLinks() {
    var codeValue = sessionStorage.getItem('campaignCode');

    if (!codeValue) return;

    var links = document.querySelectorAll('a[href]');

    links.forEach(function (link) {
      var href = link.getAttribute('href');

      if (isInternalLink(href)) {
        var newHref = addParameterToUrl(href, 'code', codeValue);
        if (newHref !== href) {
          link.setAttribute('href', newHref);
        }
      }
    });
  }

  function observeDOMChanges() {
    var codeValue = sessionStorage.getItem('campaignCode');

    if (!codeValue) return;

    // Use MutationObserver to watch for new links being added to the DOM
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if the added node is a link
              if (node.tagName === 'A' && node.hasAttribute('href')) {
                var href = node.getAttribute('href');
                if (isInternalLink(href)) {
                  var newHref = addParameterToUrl(href, 'code', codeValue);
                  if (newHref !== href) {
                    node.setAttribute('href', newHref);
                  }
                }
              }

              // Check for links within the added node
              var links = node.querySelectorAll ? node.querySelectorAll('a[href]') : [];
              links.forEach(function (link) {
                var href = link.getAttribute('href');
                if (isInternalLink(href)) {
                  var newHref = addParameterToUrl(href, 'code', codeValue);
                  if (newHref !== href) {
                    link.setAttribute('href', newHref);
                  }
                }
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    var codeParam = getUrlParameter('code');

    if (codeParam) {
      sessionStorage.setItem('campaignCode', codeParam);
    } else {
      sessionStorage.removeItem('campaignCode');
    }

    processLinks();

    observeDOMChanges();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processLinks);
    }
  }

  init();
})(); 